import { useTranslation } from 'react-i18next';

function Hero({ itemCount }) {
  const { t } = useTranslation();
  const itemsLabel = itemCount != null
    ? t('hero.itemsAvailable', { count: itemCount })
    : t('hero.itemsUnknown');

  return (
    <section className="hero">
      <img
        src={`${process.env.PUBLIC_URL}/hero-sunset.jpg`}
        alt=""
        className="hero-bg"
        aria-hidden="true"
      />
      <div className="hero-overlay" aria-hidden="true" />
      <div className="hero-content">
        <div className="hero-eyebrow">
          <span className="eyebrow-line"></span>
          {t('hero.eyebrow')}
        </div>
        <h1 className="hero-title">
          <span className="outline">{t('hero.titleOutline')}</span><br />
          <span className="accent">{t('hero.titleAccent')}</span><br />
          {t('hero.titleLine3')}
        </h1>
        <div className="hero-row">
          <div className="hero-left">
            <p className="hero-desc">
              {t('hero.desc')}
            </p>
            <div className="hero-actions">
              <a href="#categories" className="btn btn-primary">{t('hero.browseGear')}</a>
              <a href="#contact" className="btn btn-outline">{t('hero.getInTouch')}</a>
            </div>
          </div>
          <div className="hero-right">
            <div>{t('hero.status')} <span className="val">{t('hero.statusOnline')}</span></div>
            <div>{t('hero.location')} <span className="val">{t('hero.locationVal')}</span></div>
            <div>{t('hero.items')} <span className="val">{itemsLabel}</span></div>
            <div>{t('hero.rental')} <span className="val">{t('hero.rentalVal')}</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
